import React from 'react';
import { ProgressIndicator} from '@veneer/core';


const LoadingIndicator = () =>{
    return(
        <div>
            <ProgressIndicator className="progress-indicator"/>
            <div className="loading-overlay"></div>
        </div>
    );
}

export default LoadingIndicator;